import React, { useContext, useRef, useState } from "react";
import { flatten, get, isEmpty, union } from "lodash";
import { Form, Dropdown, Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import { faPencilAlt } from "@fortawesome/pro-light-svg-icons";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  ManagePlanLayout,
  FieldTextarea,
  AddPlans,
  FieldInput,
  FieldButtonGroup,
  FieldDropSide,
  AddButton,
  MultiSelectDropdown,
  Link,
  FieldMultiSelectButtonGroup,
  CsplTable as Table,
  DropdownWithImage,
  DeleteWarning,
  DatePicker,
  LoaderWrapper,
  FieldInputYearBox,
  FieldInputMonthBox,
  FieldInputNumber,
  SearchableList,
} from "../../../components";
import {
  MANAGE_PLAN_ROUTES,
  managePlanFormNames,
  formFields,
  FLOW_TYPES,
  getPathWithParam,
  required,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  ELIGIBILITY_RULE_MAPPING,
  yesNoOptions,
  clearFieldValues,
  transformToMultiselectSave,
  tranformListToDropdownValues,
  toMultiSelectValueById,
  getAdvancedPathWithParam,
  usDateFormat,
  getParamsFromQueryString,
  LTPTVestingComputationPeriod,
  LTPTServiceCreditPeriod,
  toMultiSelectValue,
} from "../../../utils";
import {
  clearLocalCacheByModel,
  createPlanStore,
  savePlanDetailsAction,
  setManagePageLevelData,
  setManagePlanLocalCache,
  setManagePlanToastInfo,
  setchangeReviewFlag,
} from "../../../contexts";
import {
  useDeepEffect,
  useRequest,
  useRouterParams,
  useTableChecboxSelect,
} from "../../../abstracts";
import ExclusionsForm from "./ExclusionsForm";
import EligibilityRuleForm from "./EligibilityRuleForm";
import {
  getClassificationCodes,
  getEligibleRule,
  getPlanEligibilityMasterData,
  savePlanEligibilty,
  getPlanEligibilty,
  deletePlanEligibilty,
  deletePlanAmendment,
  savePlanAmendmentEligibilty,
  listEligibleRule,
  getPlanEligibleMasterLTPTData,
  listSource,
  getManageEligibleRule,
} from "../../../services";
import { faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import month from "../../../mocks/month.json";

const columns = [
  {
    label: "Description",
    className: "column-addtional-Eligibility-description",
    columnName: "description",
    link: MANAGE_PLAN_ROUTES.ADDITIONAL_ELIGIBILITY_RULE,
  },
];

const AddEligibilityContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(createPlanStore);
  const {
    flow,
    planId,
    eligibilityIndex,
    planAmendmentId,
    clickedOn,
  } = useRouterParams();
  const dirtyCheck = getParamsFromQueryString("dirtyCheck");

  const [getResponse, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  // const [toggle, setToggle] = useState(true);
  // const {response: getResponse, loading } = useRequest({
  //   method : getPlanEligibilty,
  //   payload: {
  //     eligibilityId:eligibilityIndex,
  //   amendmentId:planAmendmentId},
  //   defaultResponse: [],
  // });
  const formName = managePlanFormNames.ADD_ELIGIBILITY;
  const intEligibilityIndex = parseInt(eligibilityIndex, 10);
  const planData = get(state, "api.reviewAndPlanDetail", {});
  //const apiData = get(state, "api.data", {});
  const apiResponse = get(getResponse, "eligibilityRule", []);
  let eligibilityListData = get(state, "eligibilityRules", []);
  const formValues = eligibilityListData;

  const additionalEligibilityRulesData = get(
    formValues,
    "additionalEligibilityRules",
    []
  );
  const [isModalOpen, setIsModalOpen] = useState(0);
  const [errorMsg, setErrorMsg] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const formRef = useRef();
  const [sources, setSources] = useState([]);
  const [employeeSources, setEmployeeSource] = useState([]);
  const [sourcesList, setSourcesList] = useState([]);
  const [showDeleteAmendment, setShowDeleteAmendment] = useState(false);
  const [showSaveAmendment, setShowSaveAmendment] = useState(false);
  const [eligibleRuleListData, setEligibleRuleListData] = useState([]);
  const [eligibleRuleListData1, setEligibleRuleListData1] = useState([]);
  const [masterLTPT, setMasterLTPT] = useState();
  const [dropdownDetails, setDropdownDetails] = useState({});
  const handleClose = () => {
    setIsModalOpen(false);
  };

  const DeleteToastMessage = "You are attempting to delete Eligibility Rule.";
  const DeleteToastMessageHead = "Delete Eligibility Rule?";

  const fields = formFields[formName];
  const formValuesExcludedClassifications =
    get(formValues, "exclusionFromRule.excludedClassifications", []) ?? [];
  useDeepEffect(() => {
    setIsLoading(true);
    listSource(parseInt(planId))
      .then((response) => {
        setIsLoading(false);
        setSources(response.employerSourcesList);
        setEmployeeSource(
          response?.employerSourcesList
            ?.filter((val) => val.sourceType == 1 && val.sourceCategory == 2)
            ?.map((source) => ({
              label: source.sourceName,
              value: source.id,
            }))
        );
      })
      .catch((error) => {
        //Handle Error
      });
    getManageEligibleRule(parseInt(planId))
      .then((response) => {
        setEligibleRuleListData1(
          Object.values(response.eligibilityRules)
            .flatMap((e) => e)
            .map(({ id }) => id)
        );
      })
      .catch((error) => {
        //Handle Error
      });
  }, []);
  useDeepEffect(() => {
    listEligibleRule(parseInt(planId))
      .then((response) => {
        setEligibleRuleListData(
          response.eligibilityRules.filter((_) =>
            eligibleRuleListData1.includes(_.id)
          )
        );
      })
      .catch((error) => {
        //Handle Error
      });
  }, [eligibleRuleListData1]);

  useDeepEffect(() => {
    getPlanEligibleMasterLTPTData()
      .then((response) => {
        setMasterLTPT(response);
      })
      .catch((error) => {
        // console.log("Error occurred while fetching data:", error);
      });
  }, [masterLTPT]);

  useDeepEffect(() => {
    if (eligibleRuleListData) {
      if (!isEmpty(eligibleRuleListData)) {
        let eligibleRuleSources = eligibleRuleListData
          ?.filter(
            (eligibleRule) =>
              eligibleRule["eligibilityRuleFor"] === 2 &&
              eligibleRule.id &&
              eligibleRule.id != eligibilityIndex
          )
          ?.map((eligRule) => eligRule["sourceEligibilities"])
          ?.reduce(
            (previous, current) => [
              ...previous,
              ...current.reduce(
                (prev, curr) => [...prev, curr["sourceId"]],
                []
              ),
            ],
            []
          );
        setSourcesList(
          tranformListToDropdownValues(sources, "sourceName", "id").filter(
            (source) => !eligibleRuleSources.includes(source.value)
          )
        );
      }
    } else if (sources) {
      setSourcesList(tranformListToDropdownValues(sources, "sourceName", "id"));
    }
  }, [sources, eligibleRuleListData]);
  useDeepEffect(() => {
    if (isEmpty(formValues)) {
      dispatch(
        setManagePlanLocalCache({
          model: "eligibilityRules",
          data: apiResponse,
        })
      );
    }
  }, [apiResponse]);

  useDeepEffect(() => {
    if (
      eligibilityListData?.id !== eligibilityIndex &&
      eligibilityListData?.planAmendments?.id !== planAmendmentId
    ) {
      getPlanEligibilty({
        eligibilityId: eligibilityIndex,
        amendmentId: planAmendmentId,
      })
        .then((response) => {
          // setDataLoading(false);
          if (response.isSuccessful) {
            setResponse(response);
          }
        })
        .catch((error) => {
          // setDataLoading(false);
        });
    }
  }, [planAmendmentId, eligibilityIndex]);

  const onDeleteClick = () => {
    setShowWarning(true);
  };

  const handleCancelClick = () => {
    setShowWarning(false);
  };
  const handleConfirmClick2 = () => {
    setIsLoading(true);
    deletePlanEligibilty(parseInt(eligibilityIndex), parseInt(planAmendmentId))
      .then((response) => {
        setIsLoading(false);
        if (!response.isSuccessful) {
          response.errorMessages?.map((errorMessage) => {
            if (errorMessage.controlName === "EligibilityDependency") {
              setErrorMsg(
                `${errorMessage.errorCode} : ${errorMessage.message}`
              );
              setIsModalOpen(true);
            } else {
              formRef.current.setFieldTouched(errorMessage.controlName, true);
              formRef.current.setFieldError(
                errorMessage.controlName,
                `${errorMessage.errorCode} : ${errorMessage.message}`
              );
            }
          });
        } else {
          dispatch(
            setchangeReviewFlag({
              module: "eligibility",
              review: response.isCompleted,
            })
          );
          setShowDeleteAmendment(false);
          dispatch(
            setManagePlanToastInfo({
              showToast: true,
              toastMessage: "Data deleted successfully",
            })
          );
          //const newPlanId = get(response, "plan.id");
          history.push(
            getPathWithParam({
              path: MANAGE_PLAN_ROUTES.ELIGIBILITY,
              pathParam: [FLOW_TYPES.EDIT, planId],
            })
          );
          clearCache();
        }
      })
      .catch((ex) => {
        setIsLoading(false);
      });
  };
  const handleConfirmClick1 = () => {
    setIsLoading(true);
    setShowWarning(false);
    deletePlanAmendment(parseInt(eligibilityIndex), parseInt(planAmendmentId))
      .then((response) => {
        setIsLoading(false);
        if (!response.isSuccessful) {
          response.errorMessages?.map((errorMessage) => {
            if (errorMessage.controlName === "EligibilityDependency") {
              setErrorMsg(
                `${errorMessage.errorCode} : ${errorMessage.message}`
              );
              setIsModalOpen(true);
            } else {
              formRef.current.setFieldTouched(errorMessage.controlName, true);
              formRef.current.setFieldError(
                errorMessage.controlName,
                `${errorMessage.errorCode} : ${errorMessage.message}`
              );
            }
          });
        } else {
          dispatch(
            setchangeReviewFlag({
              module: "eligibility",
              review: response.isCompleted,
            })
          );
          dispatch(
            setManagePlanToastInfo({
              showToast: true,
              toastMessage: "Data deleted successfully",
            })
          );
          //const newPlanId = get(response, "plan.id");
          history.push(
            getPathWithParam({
              path: MANAGE_PLAN_ROUTES.ELIGIBILITY,
              pathParam: [FLOW_TYPES.EDIT, planId],
            })
          );
          clearCache();
        }
      })
      .catch((ex) => {
        setIsLoading(false);
      });
  };

  const clearCache = () => {
    dispatch(clearLocalCacheByModel("eligibilityRules"));
  };

  const buttons = [
    {
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.ELIGIBILITY,
        pathParam: [FLOW_TYPES.ADD, planId],
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
      //onClick: clearCache,
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.ELIGIBILITY,
        pathParam: [FLOW_TYPES.ADD, planId],
      }),
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY,
            pathParam: [
              FLOW_TYPES.SAVE,
              planId,
              intEligibilityIndex,
              planAmendmentId,
              clickedOn,
            ],
          })
        ),
    },
    {
      label: "Delete",
      variant: "danger",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: onDeleteClick,
    },
    // {
    //   label: "Save",
    //   variant: "primary",
    //   type: "submit",
    //   flow: [FLOW_TYPES.ADD],
    // },
    // {
    //   label: "Edit",
    //   variant: "primary",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   onClick: () =>
    //     history.push(
    //       getAdvancedPathWithParam({
    //         path: MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY,
    //         pathParam: [
    //           FLOW_TYPES.SAVE,
    //           planId,
    //           intEligibilityIndex,
    //           planAmendmentId,
    //           clickedOn,
    //         ],
    //       })
    //     ),
    // },
    // {
    //   label: "Save",
    //   variant: "primary",
    //   type: "submit",
    //   flow: [FLOW_TYPES.SAVE],
    // },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faTrashAlt,
    //   onClick: onDeleteClick,
    // },
  ];

  console.log(
    "fsgdgd",
    get(formValues, fields.applicableEmployeeSourceForLTPT)
  );

  const getDataForSave = (values) => {
    const {
      exclusionType,
      hire,
      hiredOnOrAfterDate,
      hiredOnOrBeforeDate,
      isBreakInService,
      breakInServiceDefinition,
      consecutiveBreaksInService,
      yearsOfServiceDefinition,
      age,
      ageMonth,
      hours,
      eligibilityCalculationPeriod,
      yearsOfServiceRequirement,
      serviceCreditPeriod,
      serviceCreditDay,
      period,
      lengthOfService,
      eligibilityRequirementMetDate,
      otherComputationalMonths,
      elapsedTimePeriod,
      eligibilityBreakInServices,
      eligibilityType,
      immediateEligibility,
      isRevaluationRequired,
      dailyHours,
      weeklyHours,
      biWeeklyHours,
      semiMonthlyHours,
      monthlyHours,
      quarterlyHours,
      semiAnnuallyHours,
      annuallyHours,
      exclusionRuleId,
      eligibilityRuleFor,
      sourceEligibilities,
      amendmentEffectiveDate,
      amendmentTitle,
      planAmendmentId,
      amendmentEffectiveEndDate,
      directAmendment,
      applicableEmployeeSourceForLTPT,
      ...rest
    } = values;

    const updatedValues = {
      ...formValues,
      ...rest,
      [fields.applicableEmployeeSourceForLTPT]: [
        ...transformToMultiselectSave(
          (values[fields.applicableEmployeeSourceForLTPT] || []).filter(
            (val) =>
              !get(formValues, "applicableEmployeeSourceForLTPT", [])
                .map((_) => _.sourceId)
                .includes(val)
          ),
          "sourceId"
        ),
        ...(
          get(formValues, "applicableEmployeeSourceForLTPT", []) || []
        )?.filter((val) =>
          (values[fields.applicableEmployeeSourceForLTPT] || []).includes(
            val.sourceId
          )
        ),
      ],
      // fields.applicableEmployeeSourceForLTPT: get(
      //   formValues,
      //   fields.applicableEmployeeSourceForLTPT
      // )
      //   ? get(formValues, fields.applicableEmployeeSourceForLTPT)
      //   : transformToMultiselectSave(
      //       applicableEmployeeSourceForLTPT,
      //       "sourceId"
      //     ),
      eligibilityRuleFor: eligibilityRuleFor || undefined,
      eligibilityToBeChecked: 0,
      immediateEligibility: immediateEligibility,
      eligibilityType: eligibilityType || undefined,
      yearsOfServiceDefinition: yearsOfServiceDefinition || undefined,
      age: age || undefined,
      ageMonth: ageMonth,
      isRevaluationRequired: isRevaluationRequired,
      period: period || undefined,
      lengthOfService: lengthOfService || undefined,
      eligibilityRequirementMetDate: eligibilityRequirementMetDate || undefined,
      hours: hours || undefined,
      dailyHours: dailyHours == 0 ? 0 : dailyHours || undefined,
      weeklyHours: weeklyHours == 0 ? 0 : weeklyHours || undefined,
      biWeeklyHours: biWeeklyHours == 0 ? 0 : biWeeklyHours || undefined,
      semiMonthlyHours:
        semiMonthlyHours == 0 ? 0 : semiMonthlyHours || undefined,
      monthlyHours: monthlyHours == 0 ? 0 : monthlyHours || undefined,
      quarterlyHours: quarterlyHours == 0 ? 0 : quarterlyHours || undefined,
      semiAnnuallyHours:
        semiAnnuallyHours == 0 ? 0 : semiAnnuallyHours || undefined,
      annuallyHours: annuallyHours == 0 ? 0 : annuallyHours || undefined,
      eligibilityCalculationPeriod: eligibilityCalculationPeriod || undefined,
      otherComputationalMonths: otherComputationalMonths || undefined,
      yearsOfServiceRequirement: yearsOfServiceRequirement || undefined,
      serviceCreditPeriod: serviceCreditPeriod || undefined,
      serviceCreditDay: serviceCreditDay || undefined,
      isBreakInService: isBreakInService,
      planAmendmentId: planAmendmentId || 0,
      planId: parseInt(planId),
      planAmendments: {
        id: planAmendmentId || 0,
        description: amendmentTitle?.trim().length > 0 ? amendmentTitle : null,
        effectiveStartDate: amendmentEffectiveDate,
        effectiveEndDate: amendmentEffectiveEndDate,
        planId: parseInt(planId),
        directAmendment: directAmendment ?? false,
      },
      [fields.sourceEligibilities]:
        eligibilityRuleFor == 2
          ? [
              ...transformToMultiselectSave(
                (values[fields.sourceEligibilities] || []).filter(
                  (val) =>
                    !get(formValues, fields.sourceEligibilities, [])
                      .map((_) => _.sourceId)
                      .includes(val)
                ),
                "sourceId"
              ),
              ...get(
                formValues,
                fields.sourceEligibilities,
                []
              )?.filter((val) =>
                (values[fields.sourceEligibilities] || []).includes(
                  val.sourceId
                )
              ),
            ]
          : [],
      exclusionFromRule: {
        id: exclusionRuleId,
        exclusionType: exclusionType,
        [fields.excludedClassifications]: [
          ...transformToMultiselectSave(
            (values[fields.excludedClassifications] || []).filter(
              (val) =>
                !get(
                  formValues,
                  "exclusionFromRule.excludedClassifications",
                  []
                )
                  .map((_) => _.employeeClassificationCodeId)
                  .includes(val)
            ),
            "employeeClassificationCodeId"
          ),
          ...(
            get(formValues, "exclusionFromRule.excludedClassifications", []) ||
            []
          )?.filter((val) =>
            (values[fields.excludedClassifications] || []).includes(
              val.employeeClassificationCodeId
            )
          ),
        ],
        dateOfHireType: hire || undefined,
        hiredOnOrAfterDate: hiredOnOrAfterDate || undefined,
        hiredOnOrBeforeDate: hiredOnOrBeforeDate || undefined,
      },
    };

    if (isEmpty(formValues)) {
      return updatedValues;
    }
    return updatedValues;
  };
  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting },
    saveMethod
  ) => {
    setIsLoading(true);
    var data = getDataForSave(values);
    saveMethod(data, dispatch, state).then((response) => {
      if (response.isSuccessful) {
        setIsLoading(false);

        setSubmitting(true);
        //const newPlanId = get(response, "plan.id");
        history.push(
          getPathWithParam({
            path: MANAGE_PLAN_ROUTES.ELIGIBILITY,
            pathParam: [FLOW_TYPES.EDIT, planId],
          })
        );
        dispatch(
          setManagePageLevelData({
            formName: formName,
            fieldData: values,
          })
        );
        dispatch(
          setchangeReviewFlag({
            module: "eligibility",
            review: response.isCompleted,
          })
        );
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
      } else {
        setIsLoading(false);
        setSubmitting(false);
        if (eligibilityIndex !== 0 && showSaveAmendment) {
          for (var i = 0; i < response?.errorMessages?.length; i++) {
            var _ = response.errorMessages[i];
            setFieldTouched(
              _.controlName == "amendmentTitle"
                ? "amendmentDescription"
                : _.controlName == "amendmentEffectiveDate"
                ? "amendmentStartDate"
                : _.controlName,
              true
            );
            setFieldError(
              _.controlName == "amendmentTitle"
                ? "amendmentDescription"
                : _.controlName == "amendmentEffectiveDate"
                ? "amendmentStartDate"
                : _.controlName,
              `${_.errorCode} : ${_.message}`
            );
          }
        } else {
          for (var i = 0; i < response?.errorMessages?.length; i++) {
            var _ = response.errorMessages[i];
            setFieldTouched(_.controlName, true);
            setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
          }
        }
      }
    });
    setDropdownDetails({});
  };
  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;

  const applicableEmployeeSourceForLTPTInitial = get(
    formValues,
    fields.applicableEmployeeSourceForLTPT
  );

  const initialValues = {};

  return (
    <Formik
      initialValues={{
        ...initialValues,
        [fields.excludedClassifications]: formValuesExcludedClassifications?.map(
          (val) => val.employeeClassificationCodeId
        ),
        [fields.additionalEligibilityRules]: get(
          formValues,
          "additionalEligibilityRules",
          []
        ),
        //[fields.eligibilityRuleFor]: get(formValues, fields.eligibilityRuleFor),
        [fields.eligibilityRuleFor]: get(formValues, fields.eligibilityRuleFor)
          ? get(formValues, fields.eligibilityRuleFor)
          : (isEmpty(eligibleRuleListData) &&
              parseInt(eligibilityIndex) == 0) ||
            !eligibleRuleListData?.some((val) => val.eligibilityRuleFor === 1)
          ? 1
          : 2,
        [fields.eligibilityName]: get(formValues, fields.eligibilityName),
        [fields.applicableEmployeeSourceForLTPT]: (
          applicableEmployeeSourceForLTPTInitial ?? []
        ).map((val) => val.sourceId),

        [fields.isLTPTApplicable]: get(
          formValues,
          fields.isLTPTApplicable,
          false
        ),
        [fields.ltptAgeInYears]: get(
          formValues,
          fields.ltptAgeInYears,
          masterLTPT?.masterLTPT[0]?.age
        ),
        [fields.ltptAgeInMonths]: get(formValues, fields.ltptAgeInMonths),
        [fields.ltptHours]: get(
          formValues,
          fields.ltptHours,
          masterLTPT?.masterLTPT[0]?.hours
        ),
        [fields.consecutiveYears]: get(
          formValues,
          fields.consecutiveYears,
          masterLTPT?.masterLTPT[0]?.consecutiveYears
        ),
        [fields.effectiveDate]: get(formValues, fields.effectiveDate),
        [fields.ltptVestingComputationPeriod]: get(
          formValues,
          fields.ltptVestingComputationPeriod
        ),
        [fields.ltptServiceCreditPeriod]: get(
          formValues,
          fields.ltptServiceCreditPeriod
        ),
        [fields.hours]: get(formValues, `${fields.hours}`, null),
        [fields.sourceEligibilities]: get(
          formValues,
          fields.sourceEligibilities,
          []
        )?.map((val) => val.sourceId),
        [fields.hours]: get(formValues, `${fields.hours}`, null),
        [fields.eligibilityDescription]: get(
          formValues,
          fields.eligibilityDescription
        ),
        [fields.exclusionType]: get(
          formValues,
          `exclusionFromRule.exclusionType`,
          null
        ),
        [fields.hire]: get(formValues, `exclusionFromRule.dateOfHireType`),
        [fields.immediateEligibility]: get(
          formValues,
          fields.immediateEligibility,
          null
        ),
        [fields.period]: get(formValues, `${fields.period}`, null),
        [fields.isBreakInService]: get(formValues, `isBreakInService`, false),
        [fields.applicableEligibilityRequirement]: get(
          formValues,
          `${fields.applicableEligibilityRequirement}`,
          null
        ),

        [fields.yearsOfServiceDefinition]: get(
          formValues,
          `${fields.yearsOfServiceDefinition}`,
          null
        ),
        [fields.age]: get(formValues, `age`),
        [fields.ageMonth]:
          get(formValues, `ageMonth`) == null || undefined
            ? 0
            : get(formValues, `ageMonth`),
        [fields.yearsOfServiceHours]: get(
          formValues,
          `${fields.yearsOfServiceHours}`,
          null
        ),
        [fields.eligibilityCalculationPeriod]: get(
          formValues,
          `${fields.eligibilityCalculationPeriod}`,
          null
        ),
        [fields.hours]: get(formValues, `${fields.hours}`),
        [fields.otherComputationalMonths]: get(
          formValues,
          `${fields.otherComputationalMonths}`
        ),
        [fields.yearsOfServiceRequirement]: get(
          formValues,
          `${fields.yearsOfServiceRequirement}`,
          null
        ),
        [fields.serviceCreditPeriod]: get(
          formValues,
          `${fields.serviceCreditPeriod}`,
          null
        ),
        [fields.serviceCreditDay]: get(
          formValues,
          `${fields.serviceCreditDay}`,
          2
        ),
        [fields.consecutiveBreaksInService]: get(
          formValues,
          fields.consecutiveBreaksInService
        ),
        [fields.breakInServiceDefinition]: get(
          formValues,
          fields.breakInServiceDefinition
        ),
        [fields.exclusionRuleId]: get(formValues, `exclusionFromRule.id`, 0),
        [fields.hiredOnOrAfterDate]: get(
          formValues,
          `exclusionFromRule.hiredOnOrAfterDate`
        ),
        [fields.hiredOnOrBeforeDate]: get(
          formValues,
          `exclusionFromRule.hiredOnOrBeforeDate`
        ),
        [fields.lengthOfServiceRequirement]: get(
          formValues,
          `${fields.lengthOfServiceRequirement}`,
          1
        ),
        [fields.daily]: get(formValues, `${fields.daily}`, null),
        [fields.monthly]: get(formValues, `${fields.monthly}`, null),
        [fields.weekly]: get(formValues, `${fields.weekly}`, null),
        [fields.biweekly]: get(formValues, `${fields.biweekly}`, null),
        [fields.semiMonthly]: get(formValues, `${fields.semiMonthly}`, null),
        [fields.quarterly]: get(formValues, `${fields.quarterly}`, null),
        [fields.semiAnnually]: get(formValues, `${fields.semiAnnually}`, null),
        [fields.annually]: get(formValues, `${fields.annually}`, null),
        [fields.employeePopulation]: get(
          formValues,
          `isRevaluationRequired`,
          false
        ),
        [fields.lengthOfService]: get(
          formValues,
          `${fields.lengthOfService}`,
          null
        ),
        [fields.period]: get(formValues, `${fields.period}`, null),
        [fields.eligibilityRequirementMetDate]: get(
          formValues,
          `${fields.eligibilityRequirementMetDate}`,
          2
        ),
        [fields.eligibilityBreakInServices]: get(
          formValues,
          fields.eligibilityBreakInServices,
          []
        ).map((item) => item.breakInServiceRuleId),
        [fields.planAmendmentId]: get(formValues, `planAmendments?.id`, null),
        [fields.amendmentEffectiveDate]: get(
          formValues,
          `planAmendments.effectiveStartDate`,
          null
        ),
        [fields.amendmentEffectiveEndDate]: get(
          formValues,
          `planAmendments.effectiveEndDate`,
          null
        ),
        [fields.amendmentTitle]: get(
          formValues,
          `planAmendments.description`,
          null
        ),
        [fields.directAmendment]: get(
          formValues,
          `planAmendments.directAmendment`,
          null
        ),
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
      innerRef={formRef}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        setValues,
        values,
        setSubmitting,
        setFieldError,
        setFieldTouched,
        errors,
        setErrors,
        resetForm,
        dirty,
        ...rest
      }) => {
        const onDaySelected = (fieldName, value) => {
          setFieldValue(fieldName, value);
        };
        // const errorSet = (fieldName,value) =>{
        //   setFieldTouched(fieldName, true);
        //   setFieldError(fieldName, value);
        // }
        console.log("values", values);

        const onBreakInServiceChange = (value) => {
          const updatedValues = clearFieldValues({
            values,
            fieldsToClear: [
              fields.breakInServiceDefinition,
              fields.consecutiveBreaksInService,
            ],
          });
          setValues({
            ...updatedValues,
            [fields.isBreakInService]: value,
          });
        };
        const handleDropdownButton = (dropdownDetails) => {
          if (!isEmpty(dropdownDetails)) {
            if (
              dropdownDetails.button === "delete" &&
              dropdownDetails.choice === "immediate"
            ) {
              setShowWarning(true);
            }
            if (
              dropdownDetails.button === "delete" &&
              dropdownDetails.choice === "amendment"
            ) {
              setShowDeleteAmendment(true);
            }
            if (
              dropdownDetails.button === "save" &&
              dropdownDetails.choice === "immediate"
            ) {
              if (planAmendmentId == 0) {
                setErrors({});
                // setFieldValue(fields.amendmentEffectiveDate,apiData.basicPlanDetails.effectiveDate?apiData.basicPlanDetails.effectiveDate:new Date());
                onFormSubmit(
                  {
                    ...values,
                    amendmentTitle: "Initial Rule",
                    amendmentEffectiveDate: planData?.effectiveDate
                      ? planData.effectiveDate
                      : new Date(),
                  },
                  { setFieldError, setFieldTouched, setSubmitting },
                  savePlanAmendmentEligibilty
                );
              } else {
                setErrors({});
                onFormSubmit(
                  {
                    ...values,
                    planAmendmentId: parseInt(planAmendmentId),
                    amendmentEffectiveDate:
                      values[fields.amendmentEffectiveDate],
                    amendmentEffectiveEndDate:
                      values[fields.amendmentEffectiveEndDate],
                    amendmentTitle: values[fields.amendmentTitle],
                  },
                  { setFieldError, setFieldTouched, setSubmitting },
                  savePlanEligibilty
                );
              }
            }
            if (
              dropdownDetails.button === "save" &&
              dropdownDetails.choice === "amendment"
            ) {
              setShowSaveAmendment(true);
            }
          }
        };

        const addAdditionalEligiblityClick = () => {
          setSubmitting(true);
          const newEligibilityId = eligibilityIndex;
          const additionalEligibilityId = (additionalEligibilityRulesData || [])
            .length;
          dispatch(
            setManagePlanLocalCache({
              model: "eligibilityRules",
              data: getDataForSave(values),
            })
          );
          window.setTimeout(() => {
            history.push(
              getAdvancedPathWithParam({
                path: MANAGE_PLAN_ROUTES.ADDITIONAL_ELIGIBILITY_RULE,
                pathParam: [
                  FLOW_TYPES.ADD,
                  planId,
                  newEligibilityId,
                  planAmendmentId ?? 0,
                  clickedOn ?? 0,
                  additionalEligibilityId,
                ],
                queryParam: `?dirtyCheck=${dirty}`,
              })
            );
          }, 10);
        };

        const editAdditionalEligibilityRuleClick = (item, index) => {
          setSubmitting(true);
          dispatch(
            setManagePlanLocalCache({
              model: "eligibilityRules",
              data: getDataForSave(values),
            })
          );
          window.setTimeout(() => {
            history.push(
              getPathWithParam({
                path: item.link,
                pathParam: [
                  FLOW_TYPES.EDIT,
                  planId,
                  intEligibilityIndex,
                  planAmendmentId,
                  clickedOn,
                  index,
                ],
              })
            );
          }, 10);
        };

        const selectedEmployeeSources =
          values[fields.applicableEmployeeSourceForLTPT];

        return (
          <LoaderWrapper isLoading={isLoading}>
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <ManagePlanLayout
                buttons={buttons}
                pageFlow={flow}
                clickedOn={clickedOn}
                eligibilityIndex={eligibilityIndex}
                layoutHeader={eligibilityIndex && "Eligibility Rule"}
                setDropdownDetails={setDropdownDetails}
                handleDropdownButton={handleDropdownButton}
                dirtyFlagCheck={dirtyCheck}
              >
                {clickedOn == 1 && (
                  <>
                    {/* {values[fields.amendmentEffectiveDate] && (
                    <div className="deleteStatusTab">
                      <FontAwesomeIcon
                        className="deleteStatusTabIcon"
                        icon={faExclamationTriangle}
                      />
                      <p className="deleteStatusTabText">
                        The provision will be deleted on the below given
                        effective date.
                      </p>
                    </div>
                  )} */}
                    <p className="plan-sub-heading">Amendment Details</p>
                    <Field
                      name={fields.amendmentTitle}
                      label="Amendment Title"
                      autoComplete="off"
                      isRequired
                      value={values[fields.amendmentTitle]}
                      onChange={handleChange}
                      disabled={isEdit}
                      size="lg"
                      max={25}
                      noLabelTransform
                      component={FieldTextarea}
                      placeHolder="Enter Title for the Amendment"
                    />
                    <Field
                      size="smd"
                      isRequired
                      label="Amendment Effective Date"
                      name={fields.amendmentEffectiveDate}
                      value={usDateFormat(
                        values[fields.amendmentEffectiveDate]
                      )}
                      noLabelTransform
                      disabled={isEdit && !isSave}
                      isDatePicker
                      onClear={() =>
                        onDaySelected(fields.amendmentEffectiveDate, null)
                      }
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.amendmentEffectiveDate, value)
                          }
                          value={usDateFormat(
                            values[fields.amendmentEffectiveDate]
                          )}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </>
                )}
                <p className="plan-sub-heading">Eligibility Details</p>
                <Field
                  isRequired
                  name={fields.eligibilityRuleFor}
                  label={"Eligibility Rule for"}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.ELIGIBILITY_TYPE
                  )}
                  selectedValue={values[fields.eligibilityRuleFor]}
                  value={values[fields.eligibilityRuleFor]}
                  onChange={(value) => {
                    setValues({
                      ...values,
                      [fields.eligibilityRuleFor]: value,
                    });
                  }}
                  component={FieldButtonGroup}
                  disabled={true}
                  size="smd"
                />

                <Field
                  isRequired
                  name={fields.eligibilityName}
                  label={"Eligibility Name"}
                  hasSuggestion
                  isSuggestionLoading={false}
                  type="text"
                  autoComplete="off"
                  value={values[fields.eligibilityName]}
                  onChange={handleChange}
                  disabled={isEdit && !isSave}
                  component={FieldInput}
                />
                <Field
                  name={fields.eligibilityDescription}
                  label="Eligibility Description"
                  autoComplete="off"
                  value={values[fields.eligibilityDescription]}
                  onChange={handleChange}
                  disabled={isEdit}
                  component={FieldTextarea}
                  size="lg"
                />
                {values[fields.eligibilityRuleFor] ===
                  ELIGIBILITY_RULE_MAPPING.Source && (
                  <Field
                    isRequired
                    label="Select Applicable sources for Eligibility rules."
                    name={fields.sourceEligibilities}
                    value={toMultiSelectValueById(
                      values[fields.sourceEligibilities],
                      sourcesList
                    )}
                    disabled={isEdit && !isSave}
                    isMultiSelect
                    popupContent={
                      sourcesList != 0 ? (
                        <MultiSelectDropdown
                          label={
                            sourcesList.length === 0
                              ? "No data available"
                              : "Select applicable sources"
                          }
                          name={fields.sourceEligibilities}
                          onSelect={(value) =>
                            setFieldValue(fields.sourceEligibilities, value)
                          }
                          value={values[fields.sourceEligibilities]}
                          options={sourcesList}
                          disabled={isEdit && !isSave}
                        />
                      ) : (
                        <DropdownWithImage
                          label="Select Applicable sources for Eligibility rules."
                          name={fields.sourceEligibilities}
                          value={values[fields.sourceEligibilities]}
                          disabled={isEdit && !isSave}
                        />
                      )
                    }
                    component={FieldDropSide}
                  />
                )}

                <p className="plan-sub-heading">Exclusions</p>
                <ExclusionsForm
                  {...{
                    fields,
                    values,
                    setValues,
                    isEdit,
                    isSave,
                    setFieldValue,
                    onDaySelected,
                    data: planData?.companyId ?? 0,
                  }}
                />
                <p className="plan-sub-heading mt-40">
                  Default Eligibility Rule
                </p>
                <EligibilityRuleForm {...{ values, fields, isEdit, isSave }} />
                {values[fields.eligibilityRuleFor] !==
                  ELIGIBILITY_RULE_MAPPING.Source && (
                  <p className="plan-sub-heading mt-40">
                    Long Term Part Time (LTPT) Eligibility
                  </p>
                )}
                {values[fields.eligibilityRuleFor] !==
                  ELIGIBILITY_RULE_MAPPING.Source && (
                  // <Field
                  //   isRequired
                  //   name={fields.isLTPTApplicable}
                  //   label="Is LTPT eligibility applicable?"
                  //   noLabelTransform={true}
                  //   size="sm"
                  //   options={yesNoOptions}
                  //   onChange={(value) => {
                  //     setToggle(true);
                  //     setFieldValue(fields.isLTPTApplicable, value);
                  //     // setFieldValue(fields.applicableEmployeeSourceForLTPT, []);
                  //     setFieldValue(fields.ltptVestingComputationPeriod, null);
                  //     setFieldValue(fields.ltptServiceCreditPeriod, null);
                  //     setFieldValue(
                  //       fields.ltptAgeInYears,
                  //       masterLTPT?.masterLTPT[0]?.age
                  //     );
                  //     setFieldValue(
                  //       fields.ltptAgeInMonths,
                  //       masterLTPT?.masterLTPT[0]?.months
                  //     );
                  //     setFieldValue(
                  //       fields.ltptHours,
                  //       masterLTPT?.masterLTPT[0]?.hours
                  //     );
                  //     setFieldValue(
                  //       fields.consecutiveYears,
                  //       masterLTPT?.masterLTPT[0]?.consecutiveYears
                  //     );
                  //     setFieldValue(
                  //       fields.effectiveDate,
                  //       masterLTPT?.masterLTPT[0]?.years
                  //     );
                  //   }}
                  //   selectedValue={values[fields.isLTPTApplicable]}
                  //   component={FieldButtonGroup}
                  //   disabled={isEdit && !isSave}
                  // />
                  <Field
                    isRequired
                    name={fields.isLTPTApplicable}
                    label="Is LTPT eligibility applicable?"
                    noLabelTransform={true}
                    size="sm"
                    options={yesNoOptions}
                    onChange={(value) => {
                      // setToggle(true);
                      if (value == true) {
                        setFieldValue(
                          fields.ltptAgeInYears,
                          masterLTPT?.masterLTPT[0]?.age
                        );
                        setFieldValue(
                          fields.ltptAgeInMonths,
                          masterLTPT?.masterLTPT[0]?.months
                        );
                        setFieldValue(
                          fields.ltptHours,
                          masterLTPT?.masterLTPT[0]?.hours
                        );

                        setFieldValue(
                          fields.consecutiveYears,
                          masterLTPT?.masterLTPT[0]?.consecutiveYears
                        );

                        setFieldValue(
                          fields.effectiveDate,
                          masterLTPT?.masterLTPT[0]?.years
                        );
                        setFieldValue(
                          fields.applicableEmployeeSourceForLTPT,
                          employeeSources.map((_) => _.value)
                        );
                      } else {
                        setFieldValue(fields.ltptAgeInYears, null);
                        setFieldValue(fields.ltptAgeInMonths, null);
                        setFieldValue(fields.ltptHours, null);
                        setFieldValue(fields.consecutiveYears, null);
                        setFieldValue(fields.effectiveDate, null);
                      }
                      setFieldValue(fields.isLTPTApplicable, value);
                      setFieldValue(fields.ltptVestingComputationPeriod, null);
                      setFieldValue(fields.ltptServiceCreditPeriod, null);
                    }}
                    selectedValue={values[fields.isLTPTApplicable]}
                    component={FieldButtonGroup}
                    disabled={isEdit && !isSave}
                  />
                )}

                {values[fields.isLTPTApplicable] == 1 && (
                  <>
                    <div className="d-flex">
                      {/* <Field
                        size="sm"
                        isRequired
                        name={fields.ltptAgeInYears}
                        type="number"
                        label="Age"
                        autoComplete="off"
                        onChange={(evt) => {
                          setFieldValue(
                            fields.ltptAgeInYears,
                            evt.target.value
                          );
                        }}
                        value={values[fields.ltptAgeInYears]}
                        component={FieldInputYearBox}
                        preventNegative={true}
                        disabled={isEdit && !isSave}
                        // validate={(value) => {
                        //   return [undefined, null, ""].includes(value)
                        //     ? "Required"
                        //     : values[fields.ltptAgeInYears] <= 21
                        //       ? "Eligibility age must be equal to or greater than 21 years and 0 months"
                        //       : undefined;
                        // }}
                      /> */}
                      <Field
                        size="xs"
                        isRequired
                        name={fields.ltptAgeInYears}
                        label="Age"
                        hasSuggestion
                        shouldDisplaySuggestion
                        suggestionDefaultText="Year(s)"
                        type="number"
                        value={values[fields.ltptAgeInYears]}
                        onChange={(evt) => {
                          setFieldValue(
                            fields.ltptAgeInYears,
                            evt.target.value
                          );
                        }}
                        disabled={isEdit && !isSave}
                        component={FieldInputNumber}
                        min={1}
                        max={99}
                      />
                      &nbsp;&nbsp;&nbsp;
                      <div
                      // style={{
                      //   marginLeft: "1rem",
                      // }}
                      ></div>
                      <div style={{ marginTop: "2rem" }}>
                        {/* <Field
                          size="sm"
                          isRequired
                          name={fields.ltptAgeInMonths}
                          type="number"
                          autoComplete="off"
                          min={1}
                          max={12}
                          onChange={(evt) => {
                            setFieldValue(
                              fields.ltptAgeInMonths,
                              evt.target.value
                            );
                          }}
                          value={values[fields.ltptAgeInMonths]}
                          component={FieldInputMonthBox}
                          preventNegative={true}
                          disabled={isEdit && !isSave}
                        /> */}
                        <Field
                          size="xs"
                          isRequired
                          name={fields.ltptAgeInMonths}
                          value={values[fields.ltptAgeInMonths]}
                          disabled={isEdit && !isSave}
                          options={month.data}
                          hasSuggestion
                          shouldDisplaySuggestion
                          suggestionDefaultText="Month(s)"
                          popupContent={
                            <SearchableList
                              isNotTypeAhead
                              label="Select month"
                              name={fields.ltptAgeInMonths}
                              selectedValue={values[fields.ltptAgeInMonths]}
                              onSelect={(e) => {
                                setValues({
                                  ...values,
                                  [fields.ltptAgeInMonths]: e,
                                });
                              }}
                              options={month.data}
                              disabled={isEdit && !isSave}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                    </div>
                    <Field
                      size="xs"
                      isRequired
                      label="Hours"
                      name={fields.ltptHours}
                      type="number"
                      autoComplete="off"
                      onChange={(evt) => {
                        setFieldValue(fields.ltptHours, evt.target.value);
                      }}
                      value={values[fields.ltptHours]}
                      component={FieldInput}
                      disabled={isEdit && !isSave}
                    />
                    {/* <Field
                      size="sm"
                      isRequired
                      name={fields.consecutiveYears}
                      type="number"
                      label="Consecutive years"
                      noLabelTransform
                      autoComplete="off"
                      onChange={(evt) => {
                        setFieldValue(
                          fields.consecutiveYears,
                          evt.target.value
                        );
                      }}
                      value={values[fields.consecutiveYears]}
                      component={FieldInputYearBox}
                      disabled={isEdit && !isSave}
                      min={1}
                      max={9}
                      preventNegative={true}
                    /> */}

                    <Field
                      size="xs"
                      isRequired
                      name={fields.consecutiveYears}
                      label="Consecutive years"
                      hasSuggestion
                      shouldDisplaySuggestion
                      suggestionDefaultText="Years"
                      type="number"
                      value={values[fields.consecutiveYears]}
                      onChange={(evt) => {
                        setFieldValue(
                          fields.consecutiveYears,
                          evt.target.value
                        );
                      }}
                      disabled={isEdit && !isSave}
                      component={FieldInputNumber}
                      min={1}
                      max={9}
                    />
                    <Field
                      isRequired
                      name={fields.ltptVestingComputationPeriod}
                      size="xxl"
                      label="Eligibility calculation period"
                      noLabelTransform
                      options={LTPTVestingComputationPeriod}
                      selectedValue={
                        values[fields.ltptVestingComputationPeriod]
                      }
                      onChange={(value) => {
                        setFieldValue(
                          fields.ltptVestingComputationPeriod,
                          value
                        );
                      }}
                      //disabled={isEdit && !isSave}
                      component={FieldButtonGroup}
                      disabled={isEdit && !isSave}
                      // validate={(value) => {
                      //   return [undefined, null, ""].includes(value)
                      //     ? "Required"
                      //     : undefined;
                      // }}
                    />
                    <Field
                      isRequired
                      name={fields.ltptServiceCreditPeriod}
                      size="xxl"
                      label="Service credit period"
                      noLabelTransform
                      options={LTPTServiceCreditPeriod}
                      selectedValue={values[fields.ltptServiceCreditPeriod]}
                      onChange={(value) => {
                        setFieldValue(fields.ltptServiceCreditPeriod, value);
                      }}
                      disabled={isEdit && !isSave}
                      component={FieldButtonGroup}
                      // validate={(value) => {
                      //   return [undefined, null, ""].includes(value)
                      //     ? "Required"
                      //     : undefined;
                      // }}
                    />
                    <Field
                      label="Applicable Employee Sources"
                      isRequired
                      name={fields.applicableEmployeeSourceForLTPT}
                      value={toMultiSelectValueById(
                        selectedEmployeeSources,
                        employeeSources
                      )}
                      //options={employeeSources}
                      isMultiSelect
                      popupContent={
                        <MultiSelectDropdown
                          //isAllSelecetedByDefault={toggle}
                          // setToggle={setToggle}
                          label="Select Applicable Employee Sources"
                          name={fields.applicableEmployeeSourceForLTPT}
                          onSelect={(value) =>
                            setFieldValue(
                              fields.applicableEmployeeSourceForLTPT,
                              value
                            )
                          }
                          value={values[fields.applicableEmployeeSourceForLTPT]}
                          options={employeeSources}
                        />
                      }
                      component={FieldDropSide}
                      disabled={isEdit && !isSave}
                    />
                    <Field
                      size="sm"
                      isRequired
                      label="Effective date"
                      name={fields.effectiveDate}
                      value={usDateFormat(values[fields.effectiveDate])}
                      isDatePicker
                      placeholder="Effective date"
                      direction="bottom"
                      onClear={() => setFieldValue(fields.effectiveDate, null)}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.effectiveDate, value)
                          }
                          value={usDateFormat(values[fields.effectiveDate])}
                        />
                      }
                      component={FieldDropSide}
                      disabled={isEdit && !isSave}
                      // validate={(value) => {
                      //   return [undefined, null, ""].includes(value)
                      //     ? "Required"
                      //     : undefined;
                      // }}
                    />
                  </>
                )}

                <p className="plan-sub-heading">Eligibility re-evaluation</p>
                <Field
                  isRequired
                  size="sm"
                  name={fields.employeePopulation}
                  label="Re-evaluate Eligibility while moving among different employee populations?"
                  options={yesNoOptions}
                  selectedValue={values[fields.employeePopulation]}
                  type="text"
                  autoComplete="off"
                  value={values[fields.employeePopulation]}
                  onChange={(value) => {
                    setFieldValue(fields.employeePopulation, value);
                  }}
                  component={FieldButtonGroup}
                  disabled={isEdit && !isSave}
                />
                <p className="plan-sub-heading">
                  Break In Service And Termination
                </p>
                <Field
                  isRequired
                  size="sm"
                  name={fields.isBreakInService}
                  label={"Break in service applicable?"}
                  options={yesNoOptions}
                  selectedValue={values[fields.isBreakInService]}
                  type="text"
                  autoComplete="off"
                  value={values[fields.isBreakInService]}
                  onChange={onBreakInServiceChange}
                  component={FieldButtonGroup}
                  disabled={
                    isEdit && !isSave
                    // values[fields.eligibilityCalculationPeriod] === 3
                  }
                />

                <div className="line-separator"></div>
                <div className="d-flex justify-content-between bg-title">
                  <div>
                    <h4 className="ft-20">Additional Eligibility Rules</h4>
                  </div>
                  <div>
                    <AddButton
                      disabled={isEdit && !isSave}
                      menu="plan"
                      subMenu="eligibility"
                      onAddClick={addAdditionalEligiblityClick}
                    />
                  </div>
                </div>

                {isEmpty(additionalEligibilityRulesData) && (
                  <AddPlans
                    menu="plan"
                    subMenu="eligibility"
                    content="No additional rules"
                    buttonLabel="Add Additional Eligibility Rule"
                    className="h-auto"
                    disabled={isEdit && !isSave}
                    onPrimaryClick={addAdditionalEligiblityClick}
                  />
                )}
                {!isEmpty(additionalEligibilityRulesData) && (
                  <div className="w-100">
                    <Table>
                      <Table.Thead>
                        <Table.Tr>
                          {columns.map((item, index) => {
                            return (
                              <Table.Th key={index} className={item.className}>
                                {item.label}
                              </Table.Th>
                            );
                          })}
                        </Table.Tr>
                      </Table.Thead>
                      <Table.Tbody>
                        {additionalEligibilityRulesData.map(
                          (additionalEligibility, index) => {
                            return (
                              <Table.Tr key={index}>
                                {columns.map((item, cellIndex) => {
                                  return (
                                    <Table.Td
                                      key={cellIndex}
                                      className={item.className}
                                    >
                                      {!isEmpty(item.link) ? (
                                        <Link
                                          onClick={() => {
                                            editAdditionalEligibilityRuleClick(
                                              item,
                                              index
                                            );
                                          }}
                                        >
                                          {
                                            additionalEligibility[
                                              item.columnName
                                            ]
                                          }
                                        </Link>
                                      ) : item.dataMapper ? (
                                        item.dataMapper[
                                          additionalEligibility[item.columnName]
                                        ]
                                      ) : (
                                        additionalEligibility[item.columnName]
                                      )}
                                    </Table.Td>
                                  );
                                })}
                              </Table.Tr>
                            );
                          }
                        )}
                      </Table.Tbody>
                    </Table>
                  </div>
                )}
                <DeleteWarning
                  DeleteToastMessageHead={DeleteToastMessageHead}
                  DeleteToastMessage={DeleteToastMessage}
                  showModal={showWarning}
                  handleConfirmClick={
                    clickedOn == 0 ? handleConfirmClick2 : handleConfirmClick1
                  }
                  handleCancelClick={handleCancelClick}
                />
                <Modal show={isModalOpen} onHide={handleClose}>
                  <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                    <div className="text-right">
                      <FontAwesomeIcon
                        icon={faTimes}
                        color="#000"
                        onClick={handleClose}
                      />
                    </div>
                    <div className="d-flex">
                      <div className="pd-15">
                        <FontAwesomeIcon
                          icon={faExclamationTriangle}
                          color="#f94f50"
                          size="3x"
                        />
                      </div>
                      <div className="remove-text">
                        <p>{errorMsg}</p>
                        <br />
                        <Button className="cancel-btn" onClick={handleClose}>
                          Ok
                        </Button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>

                <Modal show={showDeleteAmendment}>
                  <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                        borderBottom: "1px solid #BDBDBD",
                      }}
                    >
                      <p className="plan-sub-heading">Amendment Details</p>
                      <div>
                        <Button
                          className="cancel-btn mr-4"
                          onClick={() => {
                            setShowDeleteAmendment(false);
                            setDropdownDetails({});
                          }}
                          variant="outline-danger"
                        >
                          Cancel
                        </Button>
                        <Button
                          className="remove-btn"
                          onClick={() => {
                            // setShowDeleteAmendment(false);
                            setDropdownDetails({});
                          }}
                          variant="danger"
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                    <div className="deleteStatusTabModal">
                      <FontAwesomeIcon
                        className="deleteStatusTabIconModal"
                        icon={faExclamationTriangle}
                      />
                      <p className="deleteStatusTabTextModal">
                        The provision will be deleted on the below given
                        effective date.
                      </p>
                    </div>
                    <Field
                      name={fields.amendmentDescription}
                      label="Amendment Title"
                      isRequired
                      autoComplete="off"
                      value={values[fields.amendmentDescription]}
                      onChange={handleChange}
                      disabled={isEdit}
                      max={25}
                      component={FieldTextarea}
                      size="lg"
                    />
                    <Field
                      size="smd"
                      isRequired
                      label="Amendment Effective Date"
                      name={fields.amendmentStartDate}
                      value={usDateFormat(values[fields.amendmentStartDate])}
                      disabled={isEdit && !isSave}
                      isDatePicker
                      onClear={() =>
                        onDaySelected(fields.amendmentStartDate, null)
                      }
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.amendmentStartDate, value)
                          }
                          value={usDateFormat(
                            values[fields.amendmentStartDate]
                          )}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </Modal.Body>
                </Modal>

                <Modal show={showSaveAmendment}>
                  <Modal.Body style={{ borderTop: "5px solid #0ab89a" }}>
                    <LoaderWrapper isLoading={isLoading}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "10px",
                          borderBottom: "1px solid #BDBDBD",
                        }}
                      >
                        <p className="plan-sub-heading">Amendment Details</p>
                        <div>
                          <Button
                            className="cancel-btn mr-4"
                            onClick={() => {
                              setValues({
                                ...values,
                                [fields.amendmentStartDate]: null,
                                [fields.amendmentDescription]: null,
                              });
                              setFieldError([fields.amendmentStartDate], null);
                              setFieldError(
                                [fields.amendmentDescription],
                                null
                              );
                              setShowSaveAmendment(false);
                              setDropdownDetails({});
                            }}
                            variant="secondary"
                          >
                            Cancel
                          </Button>
                          <Button
                            className="remove-btn"
                            onClick={() => {
                              setErrors({});
                              onFormSubmit(
                                {
                                  ...values,
                                  planAmendmentId: 0,
                                  amendmentEffectiveDate:
                                    values[fields.amendmentStartDate],
                                  amendmentTitle:
                                    values[fields.amendmentDescription],
                                  directAmendment:
                                    values[fields.eligibilityRuleFor] == 2 &&
                                    eligibilityIndex == 0
                                      ? true
                                      : false,
                                },
                                {
                                  setFieldError,
                                  setFieldTouched,
                                  setSubmitting,
                                },
                                savePlanAmendmentEligibilty
                              );
                              setDropdownDetails({});
                            }}
                            variant="primary"
                          >
                            Save
                          </Button>
                        </div>
                      </div>
                      <Field
                        name={fields.amendmentDescription}
                        label="Amendment Title"
                        isRequired
                        autoComplete="off"
                        value={values[fields.amendmentDescription]}
                        onChange={handleChange}
                        disabled={isEdit}
                        max={25}
                        component={FieldTextarea}
                        size="lg"
                        placeHolder="Enter Title for the Amendment"
                      />
                      <Field
                        size="smd"
                        isRequired
                        label="Amendment Effective Date"
                        name={fields.amendmentStartDate}
                        value={usDateFormat(values[fields.amendmentStartDate])}
                        disabled={isEdit && !isSave}
                        isDatePicker
                        onClear={() =>
                          onDaySelected(fields.amendmentStartDate, null)
                        }
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.amendmentStartDate, value)
                            }
                            value={usDateFormat(
                              values[fields.amendmentStartDate]
                            )}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </LoaderWrapper>
                  </Modal.Body>
                </Modal>
              </ManagePlanLayout>
            </Form>
          </LoaderWrapper>
        );
      }}
    </Formik>
  );
};

export default AddEligibilityContainer;
